import React from "react";

// mui components
import { Box, Switch } from "@mui/material";

// custom components
import Body3 from "../typography/body-03";

// mui icons
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

// helper utils
import { DIRECT_PATH_CONSTANTS } from "../../utils/direct-path.constants";

// custom styles
import styles from "./index.module.scss";

// Selection stays editable until a loan number is assigned, after that it is
// locked in Logan Connect and only the DirectPath concierge can change it.
const DirectPathStatus = ({ selected, locked = false, showLabel = false, onChange }) => {
	const label = locked
		? DIRECT_PATH_CONSTANTS.STATUS_LOCKED
		: selected
			? DIRECT_PATH_CONSTANTS.STATUS_ON
			: DIRECT_PATH_CONSTANTS.STATUS_OFF;

	return (
		<Box className={styles.statusContainer}>
			{showLabel && (
				<Box className={styles.labelColumn}>
					<Body3
						text={DIRECT_PATH_CONSTANTS.BADGE_LABEL}
						fontType="semibold"
						extraClass={styles.labelText}
					/>
					<Body3
						text={label}
						extraClass={
							!locked && selected
								? `${styles.statusText} ${styles.statusTextOn}`
								: styles.statusText
						}
					/>
				</Box>
			)}

			<Box className={styles.controlRow}>
				<Switch
					checked={Boolean(selected)}
					disabled={locked}
					className={styles.directPathSwitch}
					onChange={(event) => {
						if (locked) return;
						onChange?.(event.target.checked);
					}}
					inputProps={{ "aria-label": DIRECT_PATH_CONSTANTS.STATUS_ON }}
				/>

				{locked && <LockOutlinedIcon className={styles.lockIcon} />}

				{!showLabel && (
					<Body3
						text={label}
						extraClass={
							!locked && selected
								? `${styles.statusText} ${styles.statusTextOn}`
								: styles.statusText
						}
					/>
				)}
			</Box>
		</Box>
	);
};

export default DirectPathStatus;
